import { requestWrapper } from 'e-submission/domain/data'

export const checkAccount = (user, payload) => {
  return requestWrapper
    .postRequest('checkAccount', user, payload)
    .then(({ data }) => data)
    .catch((err) => {
      return { checkAccStatus: 'ERROR' }
    })
}
